import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getCostReportsByProject } from '../services/getCostReportsByProject.service';

export const loadCostReports = createAsyncThunk(
  'expenseTracking/loadCostReports',
  async (params, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    const response = await getCostReportsByProject(selectedProjectId);

    if (Array.isArray(response)) {
      return response;
    }

    if (Array.isArray(response?.Items)) {
      return response.Items;
    }

    return [];
  }
);
